export default {
    GET_FILTER_DATA: "GET_FILTER_DATA",
    UN_PAID_INVOICES_LIST: "UN_PAID_INVOICES_LIST",
    NOTIFICATION_REDIRECT:"NOTIFICATION_REDIRECT"
}
